import { ContentType } from '../story/models/content-type.enum';
import { StoryChapterThumbnail } from '../story/models/story-chapter-thumbnail.model';
import { storyType } from '../story/state/story-type';


// thumbnail urls
export namespace Thumbnail {
  export function generateThumbnailUrls(
    storyIdChapterIdList: {originalChapterId: string, newChapterId: string, originalStoryId: string}[]
    ): Map<string, StoryChapterThumbnail> {
    return storyIdChapterIdList.reduce((acc, {originalChapterId, newChapterId, originalStoryId}) => {

      const isBookmark = ContentType.Bookmark === storyType(originalStoryId);
      const pathForStoryType = isBookmark ? 'bookmarks' : 'modules';
      const urlBase = `/thumbs/${pathForStoryType}/${originalStoryId.replace('.json', '')}`;

      const thumbnail = new StoryChapterThumbnail();
      thumbnail.storyId = originalStoryId;
      thumbnail.chapterId = originalChapterId;
      
      thumbnail.urls = {
        small: `${urlBase}/small/chapters/${originalChapterId}.jpg`,
        large: `${urlBase}/large/chapters/${originalChapterId}.jpg`
      };
      acc.set(newChapterId, thumbnail);
      return acc;

    }, new Map());
  }
}
